/* eslint-disable max-len */
import { Master } from 'types/master-data-types';

// to logic to filter out steps of tour
// isVisible is true, it will always visible
// visibleForRoutes is array of routes where this step is visible
// else it won't be visible
export const getSteps = (master: Master) => [
    {
        selector: '.navigation-menu',
        content: 'central_hub_intro',
        isVisible: true,
        padding: 0,
        stepInteraction: false,
        position: [56, 62],
    },
    {
        selector: '.new-booking',
        content: 'create_consignment',
        isVisible: true,
        padding: 4,
        stepInteraction: false,
    },
    {
        selector: '.shipment-details',
        content: 'view_shipments',
        isVisible: true,
        padding: 4,
        stepInteraction: false,
    },
    {
        selector: '.finances',
        content: 'track_finances',
        isVisible: master?.parts_to_show?.show_virtual_wallet_tab
        && master?.config?.enable_virtual_wallet
        && (
            !master?.parts_to_show?.enable_customer_config || master?.properties?.Wallet
        )
        && master?.Customer?.cnc_flag,
        padding: 4,
        stepInteraction: false,
    },
    {
        selector: '.settings',
        content: 'account_setup',
        isVisible: true,
        padding: 4,
        stepInteraction: false,
    },
    {
        selector: '.information-center',
        content: 'access_tools',
        isVisible: !master?.properties || !master?.parts_to_show?.enable_customer_config
        || (master.properties.address_book && master.customerUserPermissions?.address_book_update)
        || (master.properties.api_playground && master.customerUserPermissions?.api_playground)
        || (
            ((master?.parts_to_show?.enable_customer_config ? master?.properties?.pincode_serviceability : true)
           && !master?.config?.customer_portal_consignment_config?.is_international_client)
          || master?.config?.customer_portal_config?.show_rate_calculator
        ),
        padding: 4,
        stepInteraction: false,
    },
    {
        selector: '.consignment-tracking',
        content: 'monitor_shipment',
        isVisible: true,
        padding: 4,
        stepInteraction: false,
    },
    {
        selector: '.quick-action',
        content: 'check_serviceability',
        isVisible: ((master?.parts_to_show?.enable_customer_config ? master?.properties?.pincode_serviceability : true)
        && !master?.config?.customer_portal_consignment_config?.is_international_client)
        || master?.config?.customer_portal_config?.show_rate_calculator,
        padding: 4,
        stepInteraction: false,
    },
    {
        selector: '.wallet-balance',
        content: 'wallet_monitoring',
        isVisible: master?.Customer?.cnc_flag || false,
        padding: 4,
        stepInteraction: false,
    },
    {
        selector: '.logout-button',
        content: 'profile_settings',
        isVisible: true,
        padding: 4,
        stepInteraction: false,
    },
];
